import React from 'react';
const stats = [{
  value: '+500',
  label: 'terapeutas confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'VP',
  quote: '"Tenía pacientes que llevaban meses sin avanzar. Con los protocolos del Tomo 2 supe exactamente qué hacer. En dos sesiones el proceso se desbloqueó."',
  author: '— Valeria P., Buenos Aires | Terapeuta Holística en Consultorio Privado'
}, {
  initials: 'MR',
  quote: '"Me llevaba los casos a la cama todos los domingos. Ahora tengo un sistema para contenerme y contener al paciente. El Tomo 3 me salvó del burnout."',
  author: '— Marcela R., Rosario | Counselor — Consultorio Particular'
}, {
  initials: 'CF',
  quote: '"Tuve un paciente en crisis de ideación y no sabía cómo manejarlo. El Tomo 4 me dio el protocolo paso a paso. Por primera vez actué con claridad y sin pánico."',
  author: '— Carolina F., Córdoba | Acompañante Terapéutica Independiente'
}];
export function SocialProof() {
  return <section className="w-full px-4 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,250,252) 0%, rgb(245,243,255) 15%, rgb(245,243,255) 85%, rgb(254,242,242) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-294">
      <div className="mx-auto max-w-4xl" data-id="element-295">
        {/* Stats Grid */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-296">
          {stats.map(stat => <div key={stat.label} data-id="element-297">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-298">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-violet-700" data-id="element-299">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-300">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white border border-violet-500/20 rounded-lg p-3 shadow-sm" data-id="element-301">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center bg-violet-500/10 text-xs font-black text-violet-700 rounded-full" data-id="element-302">
                {t.initials}
              </div>
              <div data-id="element-303">
                <div className="mb-1 text-[10px] text-violet-700" data-id="element-304">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-305">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-306">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}